'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _Typography = require('../Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Divider = require('../Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
    root: {
        marginBottom: _tokens.spacingMedium
    }
};

/**
 * A component that displays the current step of the total steps
 */
var MobileStepperTitle = _react2.default.forwardRef(function (props, ref) {
    var withDivider = props.withDivider,
        children = props.children,
        classes = props.classes,
        rest = _objectWithoutProperties(props, ['withDivider', 'children', 'classes']);

    return _react2.default.createElement(
        'div',
        { className: classes.root, ref: ref },
        _react2.default.createElement(
            _Typography2.default,
            Object.assign({ variant: 'h2' }, rest),
            children
        ),
        withDivider && _react2.default.createElement(_Divider2.default, null)
    );
});

MobileStepperTitle.propTypes = {
    /**
     * The MobileStepper title value.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    /**
     * @ignore
     */
    classes: _propTypes2.default.object,
    /**
     * Props will be passed into the rendered `<Typography>` component.
     */
    props: _propTypes2.default.object,
    /**
     * Render the MobileStepperTitle with a divider. Set false to use without a Divider.
     */
    withDivider: _propTypes2.default.bool
};

MobileStepperTitle.defaultProps = {
    withDivider: true
};

MobileStepperTitle.displayName = 'MobileStepperTitle';

exports.default = (0, _styles2.default)(styles)(MobileStepperTitle);